import React from 'react';
import { useTranslation } from 'react-i18next';
import { PiExclamationMarkLight, PiUserCircleCheckLight, PiUserCirclePlusLight } from 'react-icons/pi';
interface ImportSummary {
  added: { name: string; email: string }[];
  updated: { name: string; email: string }[];
  errors: { client: string; error: string }[];
  total_added: number;
  total_updated: number;
  total_errors: number;
}

interface ImportSummaryModalProps {
  summary: ImportSummary;
}

const ImportSummaryModal: React.FC<ImportSummaryModalProps> = ({ summary }) => {
  const { t } = useTranslation();
  return (
    <div className="w-[50vw] max-h-[80vh]">
        <div className='flex gap-2 overflow-y-auto w-full'>
      {/* Added Clients Section */}
      <div className="mb-6  w-full">
        <h4 className="text-lg font-medium text-gray-700 dark:text-gray-300 flex items-center mb-3">
          <PiUserCirclePlusLight className="h-6 w-6 text-success-500 me-2" />
          {t('Added Contacts')} ({summary.total_added})
        </h4>
        {summary.added.length > 0 ? (
          <div className="space-y-3">
            {summary.added.map((client, index) => (
              <div
                key={index}
                className="flex items-center p-3 bg-success-50 dark:bg-success-900/20 rounded-md border border-success-200 dark:border-success-700"
              >
                <PiUserCirclePlusLight className="h-5 w-5 text-success-500 me-3" />
                <div>
                  <p className="text-sm font-medium text-gray-800 dark:text-gray-200">{client.name}</p>
                  <p className="text-xs text-gray-600 dark:text-gray-400">{client.email}</p>
                </div>
              </div>
            ))}
          </div>
        ) : (
          <p className="text-sm text-gray-500 dark:text-gray-400 italic">{t('No contacts added.')}</p>
        )}
      </div>

      <div className="mb-6 w-full">
        <h4 className="text-lg font-medium text-gray-700 dark:text-gray-300 flex items-center mb-3">
          <PiUserCircleCheckLight className="h-6 w-6 text-info-500 me-2" />
          {t('Existing Contacts')} ({summary.total_updated})
        </h4>
        {summary.updated.length > 0 ? (
          <div className="space-y-3">
            {summary.updated.map((client, index) => (
              <div
                key={index}
                className="flex items-center p-3 bg-info-50 dark:bg-info-900/20 rounded-md border border-info-200 dark:border-info-700"
              >
                <PiUserCircleCheckLight className="h-5 w-5 text-info-500 me-3" />
                <div>
                  <p className="text-sm font-medium text-gray-800 dark:text-gray-200">{client.name}</p>
                  <p className="text-xs text-gray-600 dark:text-gray-400">{client.email}</p>
                </div>
              </div>
            ))}
          </div>
        ) : (
          <p className="text-sm text-gray-500 dark:text-gray-400 italic">{t('No contacts updated.')}</p>
        )}
      </div>
      </div>

      <div className="mb-6">
        <h4 className="text-lg font-medium text-gray-700 dark:text-gray-300 flex items-center mb-3">
          <PiExclamationMarkLight className="h-6 w-6 text-danger-500 me-2" />
          {t('Errors')} ({summary.total_errors})
        </h4>
        {summary.errors.length > 0 ? (
          <div className="space-y-3">
            {summary.errors.map((error, index) => (
              <div
                key={index}
                className="flex items-center p-3 bg-danger-50 dark:bg-danger-900/20 rounded-md border border-danger-200 dark:border-danger-700"
              >
                <PiExclamationMarkLight className="h-5 w-5 text-danger-500 me-3" />
                <div>
                  <p className="text-sm font-medium text-gray-800 dark:text-gray-200">{error.client}</p>
                  <p className="text-xs text-gray-600 dark:text-gray-400">{error.error}</p>
                </div>
              </div>
            ))}
          </div>
        ) : (
          <p className="text-sm text-gray-500 dark:text-gray-400 italic">{t('No errors encountered.')}</p>
        )}
      </div>
    </div>
  );
};

export default ImportSummaryModal;